<template>
  <!-- 活动信息买赠 -->
  <div class="con">
    <van-action-sheet v-model="show" title="优惠促销" @close="close">
      <div class="content border_top1px">
        <!-- 优惠券列表 -->
        <div v-if="skuModel && skuModel.showCoupon" class="coupon_section">
          <div
            v-for="(coupon, idx) in skuModel.couponProductList"
            :key="'sheet-coupon-' + idx"
            class="coupon_card"
          >
            <div class="coupon_main">
              <div class="coupon_title font14 font_weight600">
                {{ coupon.couponTypeStr || "" }}券
              </div>
              <div class="coupon_msg font12">
                {{ coupon.couponMessageStr || "" }}
              </div>
              <div class="coupon_date font10">
                {{ coupon.couponSpecifyMessage || "" }}; 有效期至{{
                  formatDate(coupon.endDate)
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- 买赠活动信息 -->
        <div v-if="skuModel && skuModel.gift" class="gift_section">
          <div
            class="font12 font_weight400 colo087 text_left line_height_17 free_pad border_top1px"
          >
            <span class="tag_gift_sheet">买赠</span>
            <div>
              {{ skuModel.gift.name || skuModel.gift.activityName }}
            </div>
          </div>
          <!-- 赠品卡片 -->
          <div
            v-for="(item, index) in skuModel.gift.gift ||
              skuModel.gift.spus ||
              []"
            :key="index"
            class="gift_item border_top1px clearfix"
          >
            <div class="left product_img">
              <img
                :src="item.thumbnailImg || item.spuImg"
                alt=""
                class="img_img"
              />
              <img
                src="@/assets/product/icon_right_free@2x.png"
                alt=""
                class="img_icon"
              />
            </div>
            <div class="name font0 left text_left font_weight400">
              <div class="font12 colo0 name_name">
                {{ item.name }}
              </div>
              <div
                v-if="item.stock === 0 || item.stock === null"
                class="font10 colof00 name_det"
              >
                已赠完
              </div>
              <div
                class="name_spec clearfix"
                @click="goGiftSelect(index, item.id)"
                v-if="
                  (checkGiftList && checkGiftList.length) ||
                    (item.skus && Object.values(item.skus)[0])
                "
              >
                <div
                  class="left spec_bg spec_det font10 text_left font_weight400 colo055 line_height_16 font_line_1"
                >
                  规格：{{ getGiftSpecText(item) }}
                </div>
                <img
                  src="@/assets/common/icon_cell_more_24@2x.png"
                  alt=""
                  class="left more_icon"
                />
              </div>
            </div>
            <div
              class="right free_btn font10 font_weight500 colof"
              @click="goDetail(item.id)"
            >
              查看赠品
            </div>
          </div>
        </div>

        <div
          class="font14 font_weight500 colof line_height_40 btn"
          @click="close"
        >
          确认
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  props: {
    skuModel: {
      type: Object,
      default: null
    },
    checkGiftList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    goGiftSelect(index, id) {
      this.$emit("goGiftSelect", index, id);
    },
    goDetail(id) {
      this.$emit("goDetail", id);
      this.$emit("closeSheet");
    },
    formatDate(time) {
      if (!time) return "";
      const date = new Date(time);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    getGiftSpecText(item) {
      if (this.checkGiftList && this.checkGiftList.length) {
        const found = this.checkGiftList.find(g => g.spuId === item.id);
        if (found) {
          return found.spec || "";
        }
      }
      if (item.skus && Object.values(item.skus)[0]) {
        return Object.values(item.skus)[0].name || "";
      }
      return "";
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  .content {
    margin: 2px 12px 0;
    padding: 13px 0;
    .btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 20px;
      margin-top: 20px;
    }
    .free_pad {
      padding: 12px 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .gift_item {
      padding: 13px 0;
    }
    .product_img {
      width: 69px;
      position: relative;
      .img_img {
        width: 100%;
      }
      .img_icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 31px;
      }
    }
    .name {
      padding: 4px 0 0 8px;
      .name_name {
        width: 160px;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .name_det {
        padding-top: 13px;
      }
    }
    .free_btn {
      margin-top: 35px;
      line-height: 24px;
      padding: 0 12px;
      background: #e02020;
      border-radius: 12px;
    }
  }

  .coupon_section {
    margin-bottom: 12px;
  }
  .coupon_card {
    background: rgba(253, 47, 96, 0.03);
    border: 1px dashed rgba(253, 47, 96, 0.2);
    border-radius: 8px;
    padding: 10px 14px;
    margin-bottom: 8px;
    text-align: left;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .coupon_title {
    color: #fd2f60;
    margin-bottom: 4px;
  }
  .coupon_msg {
    color: #fd2f60;
    margin-bottom: 4px;
  }
  .coupon_date {
    color: #fd2f60;
    opacity: 0.8;
  }
  .tag_gift_sheet {
    background: linear-gradient(270deg, #ff5f05 0%, #ff8514 100%);
    color: #fff;
    padding: 1px 4px;
    border-radius: 1px;
    margin-right: 8px;
    font-size: 10px;
    line-height: 11px;
    height: 14px;
    box-sizing: border-box;
    display: inline-block;
    flex-shrink: 0;
  }

  .name_spec {
    margin-top: 11px;
    background: rgba(0, 0, 0, 0.03);
    display: inline-block;
    .spec_det {
      max-width: 90px;
      overflow-y: hidden;
    }
    .spec_bg {
      border-radius: 2px;
    }
    .more_icon {
      width: 16px;
    }
    .delete_icon {
      width: 16px;
    }
  }
}
</style>
